// extracted by mini-css-extract-plugin
export default {"ace-c-sidebar-expansion-button":"sidebar-expansion-button---fca41853","ace-c-sidebar-expansion-button--shrinked":"sidebar-expansion-button--shrinked---82adc2fc"};